import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { BillingService } from './billing.service';
import { PolicyService } from './policy.service';

@Injectable({
  providedIn: 'root'
})
export class SwitchPolicyEventService {

  private switchPolicySource = new BehaviorSubject<string>('');
  telecast = this.switchPolicySource.asObservable();

  constructor(
    private userService: UserService,
    private router: Router,
    private billingService: BillingService,
    private policyService: PolicyService
  ) { }


  togglePolicy(policyNumber: string, appRoleId: number) {
    this.userService.getPolicySearch(policyNumber).subscribe(
      policydata => {
        let policy = policydata.data;
        if (policy.parentPolicy !== undefined && policy.parentPolicy) {
          appRoleId = 9;
        }
        this.recallDW(policydata, appRoleId, policy, policyNumber);
      }, error => { }
    );
  }

  recallDW(policydata, appRoleId, policy, policyNumber) {
    sessionStorage.removeItem('dwDetails');
    
    // Skip DWgetSummary call for pirate ship flow
    if (this.policyService.isPirateShipFlow()) {
      this.setPermission(appRoleId, policy, policyNumber);
      return;
    }

    let dwRequest = {
      productSourceSystem: "gw",
      sourceSystemIdentifierName: "PolicyNumber",
      sourceSystemIdentifier: policydata?.data?.policyNumber,
      country: "US",
      roleType: "string",
      productType: "string"
    }
    this.billingService.DWgetSummary(dwRequest).subscribe(
      data => {
        this.setPermission(appRoleId, policy, policyNumber);
        if (data?.data?.wallet) {
          sessionStorage.setItem('dwDetails', JSON.stringify(data.data.wallet))
        }
      }, error => {
        this.setPermission(appRoleId, policy, policyNumber);
      }
    );
  }

  setPermission(appRoleId: number, policy: any, policyNumber: string) {
    this.userService.getPermissions(appRoleId, policyNumber).subscribe(
      permsdata => {
        this.userService.setUserPermissions(permsdata.data.permissions);
        sessionStorage.setItem('policyDetails', JSON.stringify(policy));
        sessionStorage.setItem('togglePolicy', JSON.stringify(policyNumber));
        sessionStorage.setItem("UserPolicyDetails", "0");
        this.switchPolicySource.next(policyNumber);
        sessionStorage.removeItem('payorId'); // Clear here in order to make sure that once policy does switch, we don't re-use the payorId from the previous policy. This also ensures that the logic check for roleID in the auth interceptor functions properly.
        this.redirectTo('claims');
      }, error => {
        console.log(error);
      });
  }

  redirectTo(url: string): void {
    //what this function essentially does is navigate to the claims page.
    //However, if we use a simple this.router.navigate(['/claims']), angular re-uses the component and does not reload it. (Causing some leftover of old policy to remain on the page)
    //So, in order to "force a page refresh", we first navigate to a random page (policy page), then redirect it back to claims.
    //This was originally going to our auth page but that caused issues, so I changed it to policy page because I think a page where the user is already logged-in would be better.
    this.router.navigateByUrl('/policies', { skipLocationChange: true }).then(() => {
      this.router.navigate([url]);
    });
  } 


  resetPolicySwitch(){
    this.switchPolicySource.next('');
  }

}

